import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { CartContext } from '../Shared/Context/CartContext';

const Checkout = () => {
    const cart = useContext(CartContext);
    // console.log(cart?.item);

    if(cart.item != [])
       {
           return (
            <div className="service-container">
              <h2>You have checked out: {cart.item?.name}</h2>
              <p>{cart.item?.description}</p>
              <h4>Price: £{cart.item?.price}</h4>
              <div className="text-center">
              </div>
            </div>
            );
       }
    
};

export default Checkout;